<script>
import AsyncUtils from '@/utils/asyncUtils'
import DOMUtils from '@/utils/DOMUtils'

export default
{
    name: 'navigation-menu',

    props:
    {
    },

    created ()
    {
        this.onRouteChanged(this.$route)
        window.addEventListener('scroll', this.onWindowScrolled, { passive: true })
    },

    render () 
    {
        return (
            <div class='navigation-menu' ref='menu'>
                <div ref='get started' on-click={() => this.onItemClicked('get started')} class='item'>
                    <button>Commencer</button>
                </div>
                <div ref='contact-us' on-click={() => this.onItemClicked('contact us')} class='item contact-us'>
                    <div class='text'>Nous Contacter</div>
                </div>
                <div ref='pricing' on-click={() => this.onItemClicked('pricing')} class='item'>
                    <div class='text'>Prix</div>
                </div>
                <div ref='features' on-click={() => this.onItemClicked('features')} class='item'>
                    <div class='text'>Fonctionnalités</div>
                </div>
                <div ref='home' on-click={() => this.onItemClicked('home')} class='item'>
                    <div class='text'>Accueil</div>
                </div>
                <div ref='title' on-click={() => this.onItemClicked('title')} class='item title'>
                    <div class='favicon' >
                        <img src={require('@/assets/img/icon.png')} />
                    </div>
                    Ma Ville
                </div>
            </div>
        )
    },

    mounted ()
    {
        if (this.$route.path == '/') this.activeItem = 'home'

        this.onWindowScrolled()
    },

    destroyed ()
    {
        window.removeEventListener('scroll', this.onWindowScrolled)
    },

    data () 
    {
        return {
            activeItem: null,
            isHidden: false
        }
    },

    watch:
    {
        activeItem (current, old)
        {
            const oldElem = this.$refs[old]
            if (oldElem)
            {
                oldElem.classList.remove('active')
            }

            const currentElem = this.$refs[current]
            if (currentElem)
            {
                currentElem.classList.add('active')
            }
        },

        isHidden ()
        {
            this.$el.style.display = this.isHidden ? 'none' : ''
        },

        $route (to, from)
        {
            this.onRouteChanged(to)
        }
    },

    computed:
    {
    },

    methods:
    {
        onWindowScrolled ()
        {
            if (this.$route.path == '/')
            {
                if (window.scrollY < 100 && DOMUtils.getMatchingMediaName() == 'mobile')
                {
                    this.isHidden = true
                }
                else
                {
                    this.isHidden = false
                }
            }

            if (window.scrollY > 100 || this.$route.meta.menuBarAlwaysLight == true)
            {
                this.$refs.menu.classList.add('light')
            }
            else
            {
                this.$refs.menu.classList.remove('light')
            }
        },

        async onItemClicked (name)
        {
            if (name == 'title')
            {
                if (this.$route.path == '/') return window.scrollTo(0, 0)
                else return this.$router.push('/')
            }
            else if (name == 'get started')
            {
                return this.$router.push('trial-request')
            }
            else if (name == 'contact us')
            {
                return this.$router.push('contact-us')
            }

            if (this.$route.path != '/') await this.$router.push('/')

            await AsyncUtils.sleep(200)

            if (name == 'home')
            {
                window.scrollTo({ top: 0, behavior: 'smooth' })
            }
            else if ([ 'features', 'pricing' ].includes(name))
            {
                document.querySelector('#' + name).scrollIntoView({ behavior: 'smooth' })
            }

            this.activeItem = name
        },

        onRouteChanged (to)
        {
            this.activeItem = null
            this.isHidden = to.meta && to.meta.hideMenuBar
        }
    },

    components:
    {
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.navigation-menu
{
    width: calc(100% - 10vw);
    padding: 0 5vw;
    top: 0;
    position: fixed;
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
    z-index: 2;
    background: transparent;
    color: white;
    border-color: white;
    margin-top: 1.5vh;
    transition: all 0.1s linear;
    user-select: none;

    .OnMobile({
        justify-content: space-between;
    });

    .OnTablet({
        width: calc(100% - 14vw);
        padding: 0 7vw;
    });

    &.light
    {
        display: flex;
        margin-top: 0;
        background: white;
        color: var(--theme-accent-color);
        border-color: var(--theme-accent-color);
        box-shadow: 0 0 5px 1px #00000033;

        .item
        {
            button
            {
                background: var(--theme-accent-color);
                color: white;
            }
        }
    }

    & .item
    {
        padding: 1.5vh 1.5vw;
        cursor: pointer;
        font-size: 1.5vw;

        .OnMobile({
            font-size: 3.5vw;
            padding: 1.5vh 2vw;
        });

        .OnDesktop({ font-size: 1vw; });
        .OnLarge({ font-size: 0.8vw; });

        &.contact-us
        {
            display: none;
            .OnDesktop({ display: revert; });
        }

        button
        {
            cursor: pointer;
            border: 1px solid white;
            border-radius: 4px;
            margin: -1.5vh 0;
            background: white;
            padding: 1.5vh 3vw;

            .OnTablet({ padding: 1.5vh 2vw; });
        }

        &.active, &:hover
        {
            .text
            {
                border-color: inherit;
            }
        }

        & .text
        {
            transition: all 0.2s linear;
            border-bottom: 1px solid transparent;
            padding-top: 5px;
            padding-bottom: 5px;

            .OnDesktop({ border-bottom-width: 2px; });
        }

        &.title
        {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-right: auto;
            font-weight: bold;
            font-family: Nunito;
            font-size: 2vw;

            .OnMobile({ display: none; });
            .OnDesktop({ font-size: 1.6vw; });
            .OnLarge({ font-size: 1.2vw; })
        }

        & .favicon
        {
            @size: 2vw;
            margin-left: auto;
            width: @size;
            height: @size;
            margin-top: 0;
            margin-right: 1vw;

            img
            {
                width: 100%;
                height: 100%;
                border-radius: 20%;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/NavigationMenu.vue